export const mbaData = [
  {
    program: "MASTER OF BUSINESS ADMINISTRATION (MBA)",
    semesters: [
      {
        semester: 1,
        section: "I SEMESTER",
        subjects: [
          {
            id: "O6ECON5022",
            name: "Managerial Economics",
            route: "/courses/mba/semester-I/Managerial-Economics",
            Study_Material: "View Subject",
            pdfKey: "MBA_MANAGERIAL_ECONOMICS",
          },
          {
            id: "O6ACCT6022",
            name: "Accounting for Managers",
            route: "/courses/mba/semester-I/Accounting-for-Managers",
            Study_Material: "View Subject",
            pdfKey: "MBA_ACCOUNTING_FOR_MANAGERS",
          },
          {
            id: "O6MGMT5102",
            name: "Dynamics of Human Behavior",
            route: "/courses/mba/semester-I/Dynamics-of-Human-Behavior",
            Study_Material: "View Subject",
            pdfKey: "MBA_DYNAMICS_OF_HUMAN_BEHAVIOR",
          },
          {
            id: "VIDEO1",
            name: "Dynamics of Human Behavior Video 1",
            route: "/courses/mba/semester-I/Dynamics-of-Human-Behavior-Video-1",
            Study_Material: "View Video",
            pdfKey: "MBA_DYNAMICS_OF_HUMAN_BEHAVIOR_VIDEO_1",
          },
          {
            id: "VIDEO2",
            name: "Dynamics of Human Behavior Video 2",
            route: "/courses/mba/semester-I/Dynamics-of-Human-Behavior-Video-2",
            Study_Material: "View Video",
            pdfKey: "MBA_DYNAMICS_OF_HUMAN_BEHAVIOR_VIDEO_2",
          },
          {
            id: "O6ANLT6282",
            name: "Information System and Business Analytics",
            route:
              "/courses/mba/semester-I/Information-System-and-Business-Analytics",
            Study_Material: "View Subject",
            pdfKey: "MBA_INFORMATION_SYSTEM_AND_BUSINESS_ANALYTICS",
          },
          {
            id: "O6MKTG5072",
            name: "Marketing Management",
            route: "/courses/mba/semester-I/Marketing-Management",
            Study_Material: "View Subject",
            pdfKey: "MBA_MARKETING_MANAGEMENT",
          },
          {
            id: "VIDEO3",
            name: "Marketing Management Video 1",
            route: "/courses/mba/semester-I/Marketing-Management-Video-1",
            Study_Material: "View Video",
            pdfKey: "MBA_MARKETING_MANAGEMENT_VIDEO_1",
          },
          {
            id: "VIDEO4",
            name: "Marketing Management Video 2",
            route: "/courses/mba/semester-I/Marketing-Management-Video-2",
            Study_Material: "View Video",
            pdfKey: "MBA_MARKETING_MANAGEMENT_VIDEO_2",
          },
          {
            id: "O6STAT6033",
            name: "Business Statistics with R",
            route: "/courses/mba/semester-I/Business-Statistics-with-R",
            Study_Material: "View Subject",
            pdfKey: "MBA_BUSINESS_STATISTICS_WITH_R",
          },
          {
            id: "O6HRMT5122",
            name: "Human Resource Management",
            route: "/courses/mba/semester-I/Human-Resource-Management",
            Study_Material: "View Subject",
            pdfKey: "MBA_HUMAN_RESOURCE_MANAGEMENT",
          },
          {
            id: "VIDEO5",
            name: "Human Resource Management Video",
            route: "/courses/mba/semester-I/Human-Resource-Management-Video",
            Study_Material: "View Video",
            pdfKey: "MBA_HUMAN_RESOURCE_MANAGEMENT_VIDEO",
          },
        ],
      },
      {
        semester: 2,
        section: "II SEMESTER",
        subjects: [
          {
            id: "O6MGMT5192",
            name: "International Business Management",
            route: "/courses/mba/semester-II/International-Business-Management",
            Study_Material: "View Subject",
            pdfKey: "MBA_INTERNATIONAL_BUSINESS_MANAGEMENT",
          },
          {
            id: "VIDEO6",
            name: "Digital Innovation and Transformation",
            route:
              "/courses/mba/semester-II/Digital-Innovation-and-Transformation-video",
            Study_Material: "View video",
            pdfKey: "MBA_DIGITAL_INNOVATION_AND_TRANSFORMATION_VIDEO",
          },
          {
            id: "VIDEO7",
            name: "Digital Marketing",
            route: "/courses/mba/semester-II/Digital-Marketing-video",
            Study_Material: "View video",
            pdfKey: "MBA_DIGITAL_MARKETING_VIDEO",
          },
          {
            id: "VIDEO8",
            name: "Employee Relationship Management",
            route:
              "/courses/mba/semester-II/Employee-Relationship-Management-video",
            Study_Material: "View video",
            pdfKey: "MBA_EMPLOYEE_RELATIONSHIP_MANAGEMENT_VIDEO",
          },
          {
            id: "VIDEO9",
            name: "Competency mapping",
            route: "/courses/mba/semester-II/Competency-mapping-video",
            Study_Material: "View video",
            pdfKey: "MBA_COMPETENCY_MAPPING_VIDEO",
          },
          {
            id: "O6MGMT5202",
            name: "Business Research Methods",
            route: "/courses/mba/semester-II/Business-Research-Methods",
            Study_Material: "View Subject",
            pdfKey: "MBA_BUSINESS_RESEARCH_METHODS",
          },
          {
            id: "O6FINC5092",
            name: "Financial Management",
            route: "/courses/mba/semester-II/Financial-Management",
            Study_Material: "View Subject",
            pdfKey: "MBA_FINANCIAL_MANAGEMENT",
          },
          {
            id: "O6OPSM6072",
            name: "Operations Research for Managers",
            route: "/courses/mba/semester-II/Operations-Research-for-Managers",
            Study_Material: "View Subject",
            pdfKey: "MBA_OPERATIONS_RESEARCH_FOR_MANAGERS",
          },
        ],
      },
      {
        semester: 3,
        section: "III SEMESTER",
        subjects: [
          {
            id: "O6MGMT5132",
            name: "Strategic Analysis and Management",
            route:
              "/courses/mba/semester-III/Strategic-Analysis-and-Management",
            Study_Material: "View Subject",
            pdfKey: "MBA_STRATEGIC_ANALYSIS_AND_MANAGEMENT",
          },
          {
            id: "VIDE10",
            name: "Strategic Analysis and Management",
            route:
              "/courses/mba/semester-III/Strategic-Analysis-and-Management-video",
            Study_Material: "View video",
            pdfKey: "MBA_STRATEGIC_ANALYSIS_AND_MANAGEMENT_VIDEO",
          },
          {
            id: "O6OPSM6202",
            name: "Operations Management",
            route: "/courses/mba/semester-III/Operations-Management",
            Study_Material: "View Subject",
            pdfKey: "MBA_OPERATIONS_MANAGEMENT",
          },
        ],
      },
      {
        semester: 4,
        section: "IV SEMESTER",
        subjects: [
          {
            id: "O6MGMT5183",
            name: "Legal Environment of Business",
            route: "/courses/mba/semester-IV/Legal-Environment-of-Business",
            Study_Material: "View Subject",
            pdfKey: "MBA_LEGAL_ENVIRONMENT_OF_BUSINESS",
          },
          {
            id: "VIDE11",
            name: "Legal Environment of Business",
            route:
              "/courses/mba/semester-IV/Legal-Environment-of-Business-video",
            Study_Material: "View video",
            pdfKey: "MBA_LEGAL_ENVIRONMENT_OF_BUSINESS_VIDEO",
          },
          {
            id: "O6MGMT5122",
            name: "Leadership and Capacity Building",
            route: "/courses/mba/semester-IV/Leadership-and-Capacity-Building",
            Study_Material: "View Subject",
            pdfKey: "MBA_LEADERSHIP_AND_CAPACITY_BUILDING",
          },
          {
            id: "O6OPSM5162",
            name: "Total Quality Management",
            route: "/courses/mba/semester-IV/Total-Quality-Management",
            Study_Material: "View Subject",
            pdfKey: "MBA_TOTAL_QUALITY_MANAGEMENT",
          },
          {
            id: "O6OPSM6232",
            name: "Technology Management",
            route: "/courses/mba/semester-IV/Technology-Management",
            Study_Material: "View Subject",
            pdfKey: "MBA_TECHNOLOGY_MANAGEMENT",
          },
        ],
      },
    ],
  },
];
